export default __webpack_public_path__ + "static/media/Geneva-Bold.8037c08f.ttf";